import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  searchProviders,
  getProviderAddress,
} from "../../../utilities/API/applicationSubmitServices";
import { toast } from "react-toastify";
export const searchProviderApi = createAsyncThunk(
  "users/searchProviderApi",
  searchProviders
);
export const getProviderAddressApi = createAsyncThunk(
  "users/getProviderAddressApi",
  getProviderAddress
);
const initialState = {
  searchProviderData: {
    PhysicianInformation: true,
    NationalProviderIdentifier: '',
    noDataFlag: false,
    isNewProvider: false,
    ProviderSearch: {},
    DateofDiagnosis: "",
    PatientsCurrentMedicationList: [],
    OtherMedicationText : "",
    TreatingPhysician: {
      IsNewTreatingPhysician: "true",
      OfficeContactEmail: "",
      OfficeContactName: "",
      pyFirstName: "",
      pyLastName: "",
      PhysicianEmailAddress: "",
      Address: [
        {
          AddressLine1: "",
          AddressLine2: "",
          City: "",
          Email: "",
          Extension: "",
          Fax: "",
          PhoneNumber: "",
          PreferredAddress: "true",
          pxObjClass: "Embed-PegaHC-Address",
          pySelected: "true",
          State: "",
          Type: "",
          ZipCode: "",
          Suite: "",
          IsVerified: "true",
          IsValid: false,
          NoMatch: false,
          PartialMatch: false,
          ExactMatch: false,
          SecInfoNotMatch: false,
        },
      ],
    },
    providerlist: [],
    treatingPhysicianModalDetails: {
      firstName: "",
      lastName: "",
      address_Type: "",
      Address_Line1: "",
      Address_Line2: "",
      City: "",
      State: "",
      Zip_Code: "",
      Phone_Number: "",
      fax: "",
      Email_Address: "",
      extension: "",
      isModalFormOpen: false,
    },
    isModalFormOpen: false,
    ProviderAddresses: [],
    addressTypes: '',
    addressTypesSelectIndex: '',
    registrationsucces: false,
    loader: false,
    address: [],
    selectedTreatingPhysician: []
  },
};
const searchProviderSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetTreatingPhysician: (state, action) => {
      state.searchProviderData = {
        PhysicianInformation: true,
        NationalProviderIdentifier: '',
        noDataFlag: false,
        isNewProvider: false,
        ProviderSearch: {},
        DateofDiagnosis: "",
        PatientsCurrentMedicationList: [],
        OtherMedicationText : "",
        TreatingPhysician: {
          IsNewTreatingPhysician: "true",
          OfficeContactEmail: "",
          OfficeContactName: "",
          pyFirstName: "",
          pyLastName: "",
          PhysicianEmailAddress: "",
          Address: [
            {
              AddressLine1: "",
              AddressLine2: "",
              City: "",
              Email: "",
              Extension: "",
              Fax: "",
              PhoneNumber: "",
              PreferredAddress: "true",
              pxObjClass: "Embed-PegaHC-Address",
              pySelected: "true",
              State: "",
              Type: "",
              ZipCode: "",
              Suite: "",
              IsVerified: "true",
              IsValid: false,
              NoMatch: false,
              PartialMatch: false,
              ExactMatch: false,
              SecInfoNotMatch: false,
            },
          ],
        },
        providerlist: [],
        treatingPhysicianModalDetails: {
          firstName: "",
          lastName: "",
          address_Type: "",
          Address_Line1: "",
          Address_Line2: "",
          City: "",
          State: "",
          Zip_Code: "",
          Phone_Number: "",
          fax: "",
          Email_Address: "",
          extension: "",
          isModalFormOpen: false,
        },
        isModalFormOpen: false,
        ProviderAddresses: [],
        addressTypes: '',
        addressTypesSelectIndex: '',
        registrationsucces: false,
        loader: false,
        address: [],
        selectedTreatingPhysician: []
      }
    },
    restTreatingPhysicianModalDetails: (state) => {
      state.searchProviderData.treatingPhysicianModalDetails = {
        firstName: "",
        lastName: "",
        address_Type: "",
        Address_Line1: "",
        Address_Line2: "",
        City: "",
        State: "",
        Zip_Code: "",
        Phone_Number: "",
        fax: "",
        Email_Address: "",
        extension: "",
        isModalFormOpen: false,
      };
    },
    updateProviderAddresses: (state, action) => {
      state.searchProviderData.ProviderAddresses = action.payload;
    },
    isModalFormOpen: (state, action) => {
      state.searchProviderData.isModalFormOpen = action.payload;
    },
    addressTypes: (state, action) => {
      state.searchProviderData.addressTypes = action.payload;
    },
    addressTypesSelectIndex: (state, action) => {
      state.searchProviderData.addressTypesSelectIndex = action.payload;
    },
    treatingPhysicianModalDetails: (state, action) => {
      state.searchProviderData.treatingPhysicianModalDetails = action.payload;
    },
    TreatingPhysicianData: (state, action) => {
      state.searchProviderData.TreatingPhysician = action.payload;
    },
    ProviderSearch: (state, action) => {
      state.searchProviderData.ProviderSearch = action.payload;
    },
    isNewProviderFalg: (state, action) => {
      state.searchProviderData.isNewProvider = action.payload;
    },
    DateofDiagnosis: (state, action) => {
      state.searchProviderData.DateofDiagnosis = action.payload;
    },
    PatientsCurrentMedicationList: (state, action) => {
      state.searchProviderData.PatientsCurrentMedicationList = action.payload
    },
    OtherMedicationText: (state, action) => {
      state.searchProviderData.OtherMedicationText = action.payload;
    },
    NationalProviderIdentifier: (state, action) => {
      state.searchProviderData.NationalProviderIdentifier = action.payload;
    },
    updateAddressesAppcreate: (state, action) => {
      let address = action.payload
      let addressArr = [];
      let tempObj;
      let mapData = address.map((x, index) => {
        if (index == state.searchProviderData.addressTypesSelectIndex) {
          tempObj = {
            Fax: state.searchProviderData.treatingPhysicianModalDetails.fax,
            PhoneNumber: state.searchProviderData.treatingPhysicianModalDetails.Phone_Number,
            Email: state.searchProviderData.treatingPhysicianModalDetails.Email_Address,
            Extension: state.searchProviderData.treatingPhysicianModalDetails.extension,
            pySelected: true
          };
        } else {
          tempObj = {
            Fax: x.Fax ? x.Fax : "",
            PhoneNumber: x.PhoneNumber ? x.PhoneNumber : "",
            Email: x.Email ? x.Email : "",
            Extension: x.Extension ? x.Extension : "",
            pySelected: false
          };
        }
        addressArr.push(tempObj);
      })
      // for(let addr in address) {
      //   if(addr == state.searchProviderData.addressTypesSelectIndex) {
      //     tempObj = {
      //       Fax: state.searchProviderData.treatingPhysicianModalDetails.fax,
      //       PhoneNumber: state.searchProviderData.treatingPhysicianModalDetails.Phone_Number,
      //       Email: state.searchProviderData.treatingPhysicianModalDetails.Email_Address,
      //       Extension: state.searchProviderData.treatingPhysicianModalDetails.extension,
      //       pySelected: true
      //     };
      //   } else {
      //     tempObj = {
      //       Fax: address[addr].Fax ? address.Fax : "",
      //       PhoneNumber: address[addr].PhoneNumber ? address[addr].PhoneNumber : "",
      //       Email: address[addr].Email ? address[addr].Email : "",
      //       Extension: address[addr].Extension ? address[addr].Extension : "",
      //       pySelected: false
      //     };
      //   }
      //   addressArr.push(tempObj);
      // }
      state.searchProviderData.address = addressArr
    },
    selectedTreatingPhysician: (state, action) => {
      state.searchProviderData.selectedTreatingPhysician = action.payload
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(searchProviderApi.pending, (state, action) => {
        state.searchProviderData.loader = true;
      })
      .addCase(searchProviderApi.fulfilled, (state, action) => {
        if (action.payload.pxResults.length > 0) {
          state.searchProviderData.providerlist = action.payload.pxResults;
          state.searchProviderData.noDataFlag = true;
        } else {
          toast.error("No records found")
          state.searchProviderData.providerlist = [];
          state.searchProviderData.noDataFlag = true;
        }
      })
      .addCase(searchProviderApi.rejected, (state, action) => {
        toast.error(action.error.message);
        state.searchProviderData.loader = false;
      })
      .addCase(getProviderAddressApi.pending, (state, action) => {
        state.searchProviderData.loader = true;
      })
      .addCase(getProviderAddressApi.fulfilled, (state, action) => {
        let arr = [];
        let data = action.payload.Address
          ? action.payload.Address.map((address, i) => {
            let value =
              address.Type +
              "(" +
              address.AddressLine1 +
              ", " +
              address.City +
              ", " +
              address.State +
              " - " +
              address.ZipCode +
              ")";
            let obj = { key: i, value: value };
            // let obj = { key: i, value: address.Type }
            arr.push(obj);
          })
          : null;
        state.searchProviderData.addressTypes = arr;
        state.searchProviderData.ProviderAddresses = action.payload.Address;
      })
      .addCase(getProviderAddressApi.rejected, (state, action) => {
        toast.error(action.error.message);
        state.searchProviderData.loader = false;
      });
  },
});
export const {
  updateProviderAddresses,
  addressTypes,
  treatingPhysicianModalDetails,
  TreatingPhysicianData,
  ProviderSearch,
  isNewProviderFalg,
  restTreatingPhysicianModalDetails,
  isModalFormOpen,
  DateofDiagnosis,
  PatientsCurrentMedicationList,
  OtherMedicationText,
  NationalProviderIdentifier,
  updateAddressesAppcreate,
  addressTypesSelectIndex,
  resetTreatingPhysician,
  selectedTreatingPhysician
} = searchProviderSlice.actions;
export default searchProviderSlice.reducer;
